import dayjs from 'dayjs';
import ptBr from 'dayjs/locale/pt-br';
import localeData from 'dayjs/plugin/localeData';

dayjs.extend(localeData);
dayjs.locale(ptBr);
export default {
  frequency: 'Frequência',
  status: 'Status',
  type: 'Tipo',
  contract: 'Contrato',
  executionStatus: 'Status',
};

export const locale = {
  months: dayjs.months(),
  weekDays: dayjs.weekdays().reduce((acc, day) => ([...acc, {
    name: day,
    short: day.substring(0, 1),
    isWeekend: day === dayjs.weekdays()[0] || day === dayjs.weekdays()[6],
  }]), []),
  weekStartingIndex: 0,
  getToday(gregorainTodayObject) {
    return gregorainTodayObject;
  },
  toNativeDate(date) {
    return new Date(date.year, date.month - 1, date.day);
  },
  getMonthLength(date) {
    return new Date(date.year, date.month, 0).getDate();
  },
  transformDigit(digit) {
    return digit;
  },
  nextMonth: 'Proximo mês',
  previousMonth: 'Mês anterior',
  openMonthSelector: 'Abrir seleção de meses',
  openYearSelector: 'Abrir seleção de anos',
  closeMonthSelector: 'Fechar seleção de meses',
  closeYearSelector: 'Fechar seleção de anos',
  defaultPlaceholder: 'Selecione...',
  from: 'De',
  to: 'Até',
  digitSeparator: ',',
  yearLetterSkip: 0,
  isRtl: false,
};
